export default (options = {}) => {
  const {
    defaultValue = 'primary',
  } = options;

  return {
    props: {
      themeType: {
        type: String,
        validator: (value) => [
          'background',
          'primary',
          'accent-complementary',
          'success',
          'danger',
          'warn',
          'info',
          'contrast',
          'accent',
        ].includes(value),
        default: defaultValue,
      },
    },
  };
};
